<template>
  <div>
    <button
      :class="notifyClasses"
      @click="
        !$auth.loggedIn ? $auth.openAuthModal() : (notifyMeModalOpen = true)
      "
    >
      Notify Me
    </button>
    <button
      v-if="notificationChecked"
      class="button disable-top"
      @click="disableNotification"
    >
      Disable notification
    </button>
    <NotifyMeModal
      :visible="notifyMeModalOpen"
      :product-id="product.product_id"
      @closed="notifyMeModalOpen = false"
    />
  </div>
</template>

<script>
import {
  disableNotificationService,
  requestedNotification,
} from '#common/utils/catalog'

export default {
  components: {
    NotifyMeModal: defineAsyncComponent(
      () => import('#common/components/NotifyMe/NotifyMeModal'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notifyMeModalOpen: false,
    }
  },
  computed: {
    notificationChecked() {
      return requestedNotification(this.$auth.user, this.product.product_id)
    },
    notifyClasses() {
      return {
        'notify-me': true,
        checked: this.notificationChecked,
      }
    },
  },
  methods: {
    async disableNotification() {
      await disableNotificationService(
        this.$axios,
        this.product.product_id,
        this.$auth.user,
      )
    },
  },
}
</script>
